import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import React from 'react';
import { connect } from 'react-redux';
import { Modal, useIsMobileDimension } from '@beef/ui-kit';
import { compose } from '@beef/utils';
import { getHeaderConfigText } from "../../../../store/infoCards/selectors";
import { closeInfoCard } from "../../../../store/infoCards/actions";
import { getIsSupportModalOpen } from "../../../../store/selectors";
import { getSupportInfoListItems } from "../../../../store/blocks/infoCards/selectors";
import { AppDownloadPopup } from "../AppDownloadPopup";
import { SupportInfoListPopup } from "../SupportInfoListPopup";
import { excludeChat, handleChangePopupStep } from "./utils";
var _InfoCardsModal = function _InfoCardsModal(_ref) {
  var changePopup = _ref.changePopup,
    headerConfigText = _ref.headerConfigText,
    isOpen = _ref.isOpen,
    onClose = _ref.onClose,
    supportInfoList = _ref.supportInfoList;
  var isMobile = useIsMobileDimension();
  var items = supportInfoList.filter(function (card) {
    return excludeChat(card, isMobile) && card;
  });
  return /*#__PURE__*/React.createElement(Modal, {
    headerBarConfig: _objectSpread(_objectSpread({}, headerConfigText), {}, {
      backButtonClick: changePopup
    }),
    isOpen: isOpen,
    onClose: onClose,
    size: "s",
    "data-t-id": "components-InfoCardsModal"
  }, /*#__PURE__*/React.createElement(AppDownloadPopup, {
    "data-t-id": "components-InfoCardsModal"
  }), /*#__PURE__*/React.createElement(SupportInfoListPopup, {
    items: items
  }));
};
var mapStateToProps = function mapStateToProps(state) {
  return {
    headerConfigText: getHeaderConfigText(state),
    isOpen: getIsSupportModalOpen(state),
    supportInfoList: getSupportInfoListItems(state)
  };
};
var mapDispatchToProps = {
  changePopup: handleChangePopupStep,
  onClose: closeInfoCard
};
var connector = connect(mapStateToProps, mapDispatchToProps);
export var InfoCardsModal = compose(connector)(_InfoCardsModal);